import React from 'react'

export default function InputAnswerCDMQB(props) {
    return (
        <div>
            <p className='simulationBodyTextCDMQB warningTextCDMQB'>You may list up to {props.simulationData.qo[props.currentQuestion - 1].MAXACCEPTEDANSWERS} responses. You may need to use the scroll bar 
            at the right to view all available text boxes.
            </p>
            <div className='simulationBodyAnswersContainerCDMQB'>
                {props.answerList[props.currentQuestion - 1].map((value, index) => (
                    <div className='simulationBodyAnswerWrapperCDMQB' key={`inputAnswer${index}`}>
                        <h3 className='simulationBodyHeaderCDMQB simulationBodyAnswerNumberCDMQB'>{index + 1}</h3>
                        <input className='simulationBodyAnswerInputCDMQB' value={value} onChange={(e) => props.modifyInputAnswer(e, index)}/>
                    </div>
                ))}
            </div>
        </div>
    )
}